<i18n src="./resources/locales.json"></i18n>

<template>
  <div>
    <div class="primary-title xtium-title">{{ $t('businessProcess') }}</div>
    <EcsBusinessProcessSingleSelection
      itemValue="endPoint"
      itemText="name"
      :label="$t('selectBusinessProcess')"
      :items="availableBusinessProcesses"
      :onValueChange="onBusinessProcessChange"
      :value="selectedBusinessProcesses[0]"
    >
      <template v-slot:bp-list-item="{ item, on, attrs }">
        <v-list-item v-bind="attrs">
          <v-list-item-content v-on="on" class="cursor-pointer">
            <v-list-item-title v-text="item['name']"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="item.endPoint !== '100'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-on="on" v-bind="attrs">
                  <v-icon color="grey lighten-1" @click="() => onBpDelete(item)">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('clearTheme') }}</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </template>
    </EcsBusinessProcessSingleSelection>
    <EcsChatUrl />
    <div>
      <v-checkbox
        id="ecs-business-process-override-theme"
        :input-value="overrideDefaultTheme"
        :label="$t('customTheme')"
        hide-details
        :disabled="disabled"
        @change="onOverrideChange"
      ></v-checkbox>
    </div>
    <div id="ecs-business-process-mutiple-bps" class="d-flex flex-row flex-nowrap align-center">
      <div class="d-flex align-center">{{ $t('multipleBps') }}</div>
      <v-btn :disabled="disabled || disableControls" icon @click="onMultipleBpsClick">
        <v-icon>mdi-launch</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import EcsBusinessProcessSingleSelection from '@/components/ecs-business-process-selection/EcsBusinessProcessSingleSelection';
import EcsChatUrl from '@/components/ecs-chat-url/EcsChatUrl';
import EcsDisableControlsMixin from '@/mixins/EcsDisableControlsMixin';
import { DEFAULT_URI } from '@/constants';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EcsBusinessProcess',

  components: {
    EcsBusinessProcessSingleSelection,
    EcsChatUrl
  },

  mixins: [EcsDisableControlsMixin],

  computed: {
    ...mapGetters(['theme', 'selectedBusinessProcesses', 'businessProcesses']),

    overrideDefaultTheme() {
      return this.theme.overrideDefaultTheme;
    },

    disabled() {
      return false;
      // return this.selectedBusinessProcesses.length === 1 && this.selectedBusinessProcesses[0] === DEFAULT_URI;
    },

    availableBusinessProcesses() {
      const defaultBp = { name: this.$t('default'), endPoint: DEFAULT_URI };
      return [defaultBp, ...this.businessProcesses];
    }
  },

  methods: {
    ...mapActions([
      'setSelectedBusinessProcesses',
      'updateOverrideDefaultTheme',
      'toggleBpSelectionDialog',
      'getStoredTheme',
      'deleteTheme'
    ]),

    onOverrideChange(value) {
      this.updateOverrideDefaultTheme({ payload: value, vuetify: this.$vuetify });
    },

    onBusinessProcessChange(value) {
      this.setSelectedBusinessProcesses([value]);
      if (value && this.theme.organizationId) {
        this.getStoredTheme({
          payload: { organizationId: this.theme.organizationId, uri: value },
          vuetify: this.$vuetify
        });
      }
    },

    onMultipleBpsClick() {
      this.toggleBpSelectionDialog();
    },

    onBpDelete(item) {
      this.deleteTheme({ payload: item.endPoint, vuetify: this.$vuetify });
    }
  }
};
</script>

<style></style>
